import React from 'react';
import { withRouter } from 'react-router';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles } from '@material-ui/core/styles';
import '../../styles/navs/Header.css';
import Profile from '../../components/navs/Profile';
import MaintenanceRequests from './MaintenanceRequests';
import Replacements from './Replacements';
import PreventiveMaintenance from './PreventiveMaintenance';
import DailyChecklists from './DailyChecklists';

const useStyles = makeStyles({
  menu: {
    position: 'relative',
    zIndex: 0,
    overflowY: 'visible !important',
    '&:before': {
      content: '""',
      position: 'absolute',
      top: '-30px',
      left: '-40px',
      width: 'calc(100% + 80px)',
      height: '254px',
      zIndex: 0
    },
    '& .MuiTabs-fixed, .MuiTabs-root': {
      overflow: 'visible !important'
    },

    '& .MuiTabs-flexContainer': {
      display: 'inline-block',
      background: '#fff',
      boxShadow: '0 15px 30px -4px rgba(172,180,184,0.2)',

      '& .MuiTab-root': {
        zIndex: 2,
        textTransform: 'none',
        color: '#797B88',
        '&.Mui-selected': {
          color: '#434343'
        },

        '& .MuiTab-wrapper': {
          width: 'initial',
          fontFamily: 'Open sans !important',
          fontWeight: '600',
          padding: '0 16px',
          '&:after': {
            content: '""',
            position: 'absolute',
            width: '100%',
            bottom: '-2px',
            borderBottom: '2px solid #252427'
          }
        }
      }
    },
    '& .MuiTabs-indicator': {
      bottom: 0,
      height: 3,
      background: '#252427',
      borderRadius: 0,
      zIndex: 1,
      transform: 'scaleX(0.80)'
    }
  }
});

const Maintenance = (props) => {
  const classes = useStyles();

  const { match, history } = props;
  const { params } = match;
  const { page } = params;

  const tabNameToIndex = {
    0: 'maintenanceRequests',
    1: 'replacements',
    2: 'preventiveMaintenance',
    3: 'dailyChecklists'
  };

  const indexToTabName = {
    maintenanceRequests: 0,
    replacements: 1,
    preventiveMaintenance: 2,
    dailyChecklists: 3
  };

  const [selectedTab, setSelectedTab] = React.useState(indexToTabName[page]);

  const handleChange = (event, newValue) => {
    history.push(`/maintenance/${tabNameToIndex[newValue]}`);
    setSelectedTab(newValue);
  };

  return (
    <div>
      <div className='d-flex justify-content-between align-items-center top-navs'>
        <div className='head-navs'>
          <div className={classes.menu}>
            <Tabs
              value={selectedTab}
              onChange={handleChange}
              indicatorColor='primary'
              textColor='primary'
              variant='fullWidth'
              aria-label='full width tabs example'
            >
              <Tab label='Maintenance Requests' default />
              <Tab label='Replacements' />
              <Tab label='Preventive Maintenance' />
              <Tab label='Daily Checklists' />
            </Tabs>
          </div>
        </div>
        <Profile />
      </div>

      {selectedTab === 0 && <MaintenanceRequests />}
      {selectedTab === 1 && <Replacements />}
      {selectedTab === 2 && <PreventiveMaintenance />}
      {selectedTab === 3 && <DailyChecklists />}
    </div>
  );
};

export default withRouter(Maintenance);
